import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Radium from 'radium';
import Avatar from 'shared/components/Avatar';
import { scrolled } from 'react-stay-scrolled';
import { injectIntl, intlShape } from 'react-intl';

import * as chatAppSelectors from '../../../app/ChatApp/selectors';

import styles from './styles';
import messages from './messages';

export class ChatTypingIndicator extends PureComponent {
  componentDidMount() {
    const { stayScrolled } = this.props;

    stayScrolled();
  }
  renderAvatarColumn() {
    const { avatarUrl } = this.props;

    return (
      <div style={styles.userAvatar}>
        <Avatar avatarUrl={avatarUrl} includeDefault />
      </div>
    );
  }

  renderIndicator() {
    const { intl } = this.props;

    return (
      <span style={styles.message}>
        <div style={styles.indicatorOne} aria-label={intl.formatMessage(messages.aria_label_typing_indicator)} />
        <div style={styles.indicatorTwo} aria-label={intl.formatMessage(messages.aria_label_typing_indicator)} />
        <div style={styles.indicatorThree} aria-label={intl.formatMessage(messages.aria_label_typing_indicator)} />
      </span>
    );
  }

  render() {
    return (
      <div style={styles.wrapper}>
        {this.renderAvatarColumn()}
        {this.renderIndicator()}
      </div>
    );
  }
}

ChatTypingIndicator.propTypes = {
  avatarUrl: PropTypes.string,
  stayScrolled: PropTypes.func.isRequired,
  intl: intlShape.isRequired,
};

ChatTypingIndicator.defaultProps = {
  avatarUrl: undefined,
};

export const mapStateToProps = (state, props) => {
  const getSessionAvatarUrl = chatAppSelectors.makeGetSessionAvatarUrl();
  return {
    avatarUrl: getSessionAvatarUrl(state, { item: props.session }),
  };
};

export const componentWithIntl = injectIntl(ChatTypingIndicator);
export const component = scrolled(Radium(componentWithIntl));

export default connect(mapStateToProps)(component);
